import { alpha, Components, Theme as MuiTheme } from '@mui/material';
import {
  TOGGLE_BUTTON_HEIGHTS,
  ToggleButtonColorScheme,
  ToggleButtonSize,
  // ToggleButtonVariant,
} from './toggleButtons.enums';

export const toggleButtonTheme: Components<MuiTheme> = {
  MuiToggleButton: {
    styleOverrides: {
      root: ({ theme }) => {
        return {
          borderRadius: '30px',
          backgroundColor: 'transparent',
          color: theme.palette.text.second,
          border: `1px solid ${theme.palette.info.main}`,
          gap: theme.spacing(1),
          position: 'relative',
          zIndex: 1,
          paddingLeft: '16px',
          paddingRight: '16px',

          '&:focus': {
            zIndex: 2,
          },

          '&:hover': {
            backgroundColor: alpha(theme.palette.info.main, 0.15),
          },

          '&.Mui-selected': {
            zIndex: 2,
            backgroundColor: alpha(theme.palette.info.main, 0.24),
            color: theme.palette.text.primary,
            '&:hover': {
              backgroundColor: alpha(theme.palette.info.main, 0.35),
            },
          },

          '&:disabled': {
            border: `1px solid ${theme.palette.blue.main}`,
            color: theme.palette.grey[400],
          },

          '&.Mui-selected:disabled': {
            border: `1px solid ${theme.palette.blue.main}`,
            color: theme.palette.grey[400],
          },
        };
      },
    },
    variants: [
      {
        props: { color: ToggleButtonColorScheme.PRIMARY },
        style: ({ theme }) => {
          return {
            '&:hover': {
              color: theme.palette.text.second,
              backgroundColor: alpha(theme.palette.background.button, 0.2),
            },
            '&.Mui-selected': {
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.text.opposite,

              '&:hover': {
                backgroundColor: theme.palette.primary.dark,
              },
            },
          };
        },
      },
      {
        props: { size: ToggleButtonSize.SM },
        style: ({ theme }) => ({
          height: `${TOGGLE_BUTTON_HEIGHTS[ToggleButtonSize.SM]}px`,
          minHeight: `${TOGGLE_BUTTON_HEIGHTS[ToggleButtonSize.SM]}px`,
          fontSize: theme.typography.caption?.fontSize || '0.75rem',
          minWidth: `${TOGGLE_BUTTON_HEIGHTS[ToggleButtonSize.SM] * 1.5}px`,
        }),
      },
      {
        props: { size: ToggleButtonSize.MD },
        style: ({ theme }) => ({
          height: `${TOGGLE_BUTTON_HEIGHTS[ToggleButtonSize.MD]}px`,
          minHeight: `${TOGGLE_BUTTON_HEIGHTS[ToggleButtonSize.MD]}px`,
          fontSize: theme.typography.caption?.fontSize || '0.75rem',
          minWidth: `${TOGGLE_BUTTON_HEIGHTS[ToggleButtonSize.MD] * 1.5}px`,
        }),
      },
      {
        props: { size: ToggleButtonSize.LG },
        style: ({ theme }) => ({
          height: `${TOGGLE_BUTTON_HEIGHTS[ToggleButtonSize.LG]}px`,
          minHeight: `${TOGGLE_BUTTON_HEIGHTS[ToggleButtonSize.LG]}px`,
          fontSize: theme.typography.body2?.fontSize || '0.875rem',
          minWidth: `${TOGGLE_BUTTON_HEIGHTS[ToggleButtonSize.LG] * 1.5}px`,
        }),
      },
      {
        props: { size: ToggleButtonSize.XL },
        style: ({ theme }) => ({
          height: `${TOGGLE_BUTTON_HEIGHTS[ToggleButtonSize.XL]}px`,
          minHeight: `${TOGGLE_BUTTON_HEIGHTS[ToggleButtonSize.XL]}px`,
          fontSize: theme.typography.body2?.fontSize || '0.875rem',
          minWidth: `${TOGGLE_BUTTON_HEIGHTS[ToggleButtonSize.XL] * 1.5}px`,
        }),
      },
    ],
  },
  MuiToggleButtonGroup: {
    styleOverrides: {
      root: ({ theme }) => {
        return {
          gap: 0,
          border: 'none',
          '& .MuiToggleButton-root': {
            border: `1px solid ${theme.palette.info.main}`,
            '&:not(:first-of-type)': {
              marginLeft: '-1px',
            },
          },
        };
      },
    },
    variants: [
      {
        props: { size: 'sm' },
        style: () => ({
          minHeight: '32px',
          maxHeight: '32px',
        }),
      },
      {
        props: { size: 'md' },
        style: () => ({
          minHeight: '36px',
          maxHeight: '36px',
        }),
      },
      {
        props: { size: 'lg' },
        style: () => ({
          minHeight: '42px',
          maxHeight: '42px',
        }),
      },
      {
        props: { size: 'xl' },
        style: () => ({
          minHeight: '48px',
          maxHeight: '48px',
        }),
      },
    ],
  },
};
